import { render, staticRenderFns } from "./IngredientsTableRow.vue?vue&type=template&id=0cb0881a&scoped=true&lang=pug"
import script from "./IngredientsTableRow.vue?vue&type=script&lang=js"
export * from "./IngredientsTableRow.vue?vue&type=script&lang=js"
import style0 from "./IngredientsTableRow.vue?vue&type=style&index=0&id=0cb0881a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cb0881a",
  null
  
)

export default component.exports